import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  SpeechSolSmooth,
  SpeechSolImproved,
  SpeechSolProductivity,
} from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: SpeechSolProductivity,
    title: "Enhanced Productivity",
    description:
      "Schedule simple everyday operations such as data entry and transcription, thus sparing the users from the necessity to spend time on them.",
    count: "01",
  },
  {
    logo: SpeechSolImproved,
    title: "Improved Accuracy",
    description:
      "Enhance the accuracy of entered data and decrease transcription and documentation errors by utilizing sophisticated speech recognition systems.",
    count: "02",
  },
  {
    logo: SpeechSolSmooth,
    title: "Smooth Accessibility",
    description:
      "Provide voice interfaces for the physical devices and tools that are available for users with disabilities for employment opportunities.",
    count: "03",
  },
];
const Workflow = () => {
  return (
    <div className="workflow speech_business_solutions p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Business Benefits of Voice Recognition Software Solutions</h2>
            <p>
              Incorporating speech recognition into your software may
              significantly affect your business and in the long run, boost your
              chances of standing out in your business niche.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items" style={{ background: "#F8F8FB" }}>
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
